module.exports = __webpack_public_path__ + "img/FroSmokes@3x.a003bfcc.png";